import React from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";

const TotalRow = ({ title, value }: { title: string; value: string }) => {
  return (
    <Grid item xs={6}>
      <Divider className="divider-dark" />
      <Box className="account-data">
        <Box className="data-row">
          <Typography variant="h6" component="h6">
            {title}
          </Typography>
          <Typography variant="h6" component="h6">
            {value}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default TotalRow;
